import { render } from "./DocPagination.vue?vue&type=template&id=d2a23352&scoped=true"
import script from "./DocPagination.vue?vue&type=script&lang=js"
export * from "./DocPagination.vue?vue&type=script&lang=js"

import "./DocPagination.vue?vue&type=style&index=0&id=d2a23352&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2a23352"]])

export default __exports__